module.exports = __webpack_public_path__ + "static/media/IconWarningText.40674c31.svg";